import React, { Component } from 'react';
import './Result.css';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import WeightBenefitsTabs from './WeightBenefitsTabs/WeightBenefitsTabs';
import jsPDF from 'jspdf';
import rasterizeHTML from 'rasterizehtml';

class Result extends Component {
    constructor(props) {
        super(props);
        this.state = {
            goNextStep: false,
            tabs: [],
            competeData: [],
            competeOldData: [],
            competitorsGroupsData: [],
            benefitsData: [],
            countCCWT: [],
            totalScore: '',

        }
    }

    componentWillMount() {
        let customerSegmentData ={
            projectId: this.props.projectId,
            type: 'segmentation'
        }
        let competeData ={
            projectId: this.props.projectId,
            type: 'compete'
        }
        let challengeData = {
            type : "challenge",
            projectId : this.props.projectId,
        }

        let competitorsData = {
            projectId: this.props.projectId,
            type: 'competitors'
        }

        let advantageData ={
            projectId: this.props.projectId,
            type: 'advantage'
        }

        this.props.getDifferentialAdvantage(advantageData);
        this.props.getCompetitorsGroups(competitorsData);
        this.props.getCustomerSegment(customerSegmentData);
        this.props.getCompete(competeData);
        // this.props.getChallengeStatements(challengeData);
        //this.props.getBenefits(benefitData);
    }

    onNextButtonClick = () => {

        let stepValidation;
        let dataArr = 0;
        this.state.competeData.map(item=>{
            dataArr = dataArr + +item.wt
        });

        let k = this.state.tabs.length

        let findZeroWt = this.state.competeData.find(r => r.wt === 0 || r.wt === '0');
        let findZeroCCArray = [];

        this.state.competeData.map(item=>{
            item.criticalCapacity.map(childItem=>{
                findZeroCCArray.push(childItem);
            })
        })

        let findZeroCC = findZeroCCArray.find(r => r.text === '');
        let findZeroCcWt = findZeroCCArray.find(r => r.ccWt === 0 || r.ccWt === '0');

        if( !findZeroWt && !findZeroCC && !findZeroCcWt && (dataArr === 100 * k ) ){
            stepValidation = true;
        } else {
            stepValidation = false;
        }

        if(stepValidation){

                let body = {
                    id: this.props.differentialAdvantageData.getDifferentialAdvantageData.Items[0].id,
                    projectId: this.props.projectId,
                    type: "advantage",
                    status: 'finished',
                    advantage: this.props.differentialAdvantageData.getDifferentialAdvantageData.Items[0].advantage,
                    dataBenefits: this.state.competeData
                }

                this.setState({ goNextStep : true })
                this.props.editDifferentialAdvantage(body);


                // let competitorsBody = {
                //     type : 'competitors',
                //     id : this.props.compete.competitorsGroupsData.Items[0].id,
                //     competitors : this.state.competitorsGroupsData,

                // }
                // this.props.editCompetitorsGroups(competitorsBody);



        }else {
            this.abilityToCompeteErrorModal();
        }
    }

    abilityToCompeteErrorModal = () => {
        this.setState({  abilityToCompeteError : !this.state.abilityToCompeteError })
    }

    componentWillReceiveProps(nextProps) {

        if(nextProps.differentialAdvantageData.getDifferentialAdvantageData.Count > 0 && nextProps.differentialAdvantageData.getDifferentialAdvantageData.Items[0].dataBenefits && _.isEmpty(this.state.competeData) ){

            if (!nextProps.differentialAdvantageData.differentialAdvantageFetching && !_.isEmpty(nextProps.differentialAdvantageData.getDifferentialAdvantageData.Items) && !_.isEmpty(nextProps.compete.customerSegmentData)) {
                let data =[]


                nextProps.differentialAdvantageData.getDifferentialAdvantageData.Items[0].dataBenefits.map(item=>{
                    if(!item.criticalCapacity){
                        let criticalCapacity = [{
                            text: '',
                            ccWt: item.wt
                        }];
                        item.criticalCapacity = criticalCapacity
                    }
                    data.push(item)
                })

                this.setState({
                    competeData : data,
                    editedData : true, createdData : false,
                }, () => {
                    this.totalScore();
                    this.segmentTotalScore();
                });

                let tabTitleArr = [];
                nextProps.differentialAdvantageData.getDifferentialAdvantageData.Items[0].dataBenefits.map(item=>{
                    let customerSegmentItem = nextProps.compete.customerSegmentData.find(r => r.groupId === item.groupId);

                    let segmentData = customerSegmentItem.segments.find(r => r.segmentId === item.segmentId);

                    this.state.tabs.push({
                        groupId: item.groupId,
                        groupName: customerSegmentItem.groupName,
                        segmentId: item.segmentId,
                        segmentName: segmentData.name
                        //attractivnessId: uuidv1(),
                    });

                    if(_.isEmpty(nextProps.compete.benefitsData)){
                        let benefitData = {
                            projectId: this.props.projectId,
                            type : 'benefitsLadder',
                            groupId: item.groupId,
                        }
                        this.props.getBenefits(benefitData)
                    }

                });
            }

            this.setState({ advantage : this.state.advantage, createdData : false, editedData: true })

        }

        // competeData
        if(nextProps.differentialAdvantageData.getDifferentialAdvantageData.Count > 0 && !nextProps.differentialAdvantageData.getDifferentialAdvantageData.Items[0].dataBenefits && nextProps.compete.competeData.Items && _.isEmpty(this.state.competeData) ){


            if (!nextProps.compete.competeFetching && !_.isEmpty(nextProps.compete.competeData.Items) && !_.isEmpty(nextProps.compete.customerSegmentData)) {
                let data =[]
                nextProps.compete.competeData.Items[0].dataBenefits.map(item=>{
                    if(!item.criticalCapacity){
                        let criticalCapacity = [{
                            text: '',
                            ccWt: item.wt
                        }];
                        item.criticalCapacity = criticalCapacity
                    }
                    data.push(item)
                })

                this.setState({
                    competeData : data,
                    editedData : true, createdData : false,
                }, () => {
                    this.totalScore();
                    this.segmentTotalScore();
                });

                let tabTitleArr = [];
                nextProps.compete.competeData.Items[0].dataBenefits.map(item=>{
                    let customerSegmentItem = nextProps.compete.customerSegmentData.find(r => r.groupId === item.groupId);

                    let segmentData = customerSegmentItem.segments.find(r => r.segmentId === item.segmentId);

                    this.state.tabs.push({
                        groupId: item.groupId,
                        groupName: customerSegmentItem.groupName,
                        segmentId: item.segmentId,
                        segmentName: segmentData.name
                        //attractivnessId: uuidv1(),
                    });

                    if(_.isEmpty(nextProps.compete.benefitsData)){
                        let benefitData = {
                            projectId: this.props.projectId,
                            type : 'benefitsLadder',
                            groupId: item.groupId,
                        }
                        this.props.getBenefits(benefitData)
                    }

                });
            }

            // this.setState({ advantage : this.state.advantage, createdData : false, editedData: true })

        }

        //Old Data
        if(nextProps.differentialAdvantageData.getDifferentialAdvantageData.Count > 0  && nextProps.compete.competeData.Items && _.isEmpty(this.state.competeOldData) ){
            if (!nextProps.compete.competeFetching && !_.isEmpty(nextProps.compete.competeData.Items) && !_.isEmpty(nextProps.compete.customerSegmentData)) {
                let data =[]
                nextProps.compete.competeData.Items[0].dataBenefits.map(item=>{
                    if(!item.criticalCapacity){
                        let criticalCapacity = [{
                            text: '',
                            ccWt: item.wt
                        }];
                        item.criticalCapacity = criticalCapacity
                    }
                    data.push(item)
                })

                this.setState({
                    competeOldData : data
                }, () => {
                    this.totalScore();
                    this.segmentTotalScore();
                });
            }
        }

        if( nextProps.compete.competitorsGroupsData.Count > 0 &&  nextProps.compete.competitorsGroupsData.Items[0] && nextProps.compete.competitorsGroupsData.Items[0].competitors && !_.isEmpty(nextProps.compete.competitorsGroupsData.Items[0].competitors) && _.isEmpty(this.state.competitorsGroupsData) ) {
            nextProps.compete.competitorsGroupsData.Items[0].competitors.map(item=>{
                this.state.competitorsGroupsData.push({
                    competitorId: item.competitorId,
                    competitorName: item.competitorName,
                    important: item.important,
                    indirect: item.indirect,
                    type: item.type,
                })
            })

            this.setState({ competitorsGroupsData : this.state.competitorsGroupsData })
        }

        if(nextProps.compete.benefitsData && !_.isEmpty(nextProps.compete.benefitsData) &&  _.isEmpty(this.state.benefitsData)){
            nextProps.compete.benefitsData.res.map(item=>{
                this.state.benefitsData.push({
                    benefitId: item.id,
                    groupId: nextProps.compete.benefitsData.body.groupId,
                    projectId: nextProps.compete.benefitsData.body.projectId,
                    benefitName: item.name,
                })
            })
        }

        if(nextProps.compete.benefitsData && !_.isEmpty(nextProps.compete.benefitsData) && this.state.createNewTabPending ){
            this.state.competeData.map(item=>{
                if(!item.benefitId){
                    nextProps.compete.benefitsData.res.map(benefitsItem=>{
                        if(item.groupId === nextProps.compete.benefitsData.body.groupId){
                            item.benefitId = benefitsItem.id,
                            item.wt = 0
                            this.setState({ createNewTabPending : false })

                        }
                    })
                }
            })
        }



    }

    onChangeWT = (e, data) => {
        let value = e.target.value;

        let changedItem  =  this.state.competeData.find(r => r.groupId === data.groupId && r.benefitId === data.benefitId  && r.segmentId === data.segmentId);

        changedItem.wt = value
        this.setState({ weighting: this.state.weighting }
            // , () => this.weightingNumber()
        )
    }

    onChangeCriticalCapability = (e, data, index) => {
        let value = e.target.value;
        let getCriticalCapabilityParent = this.state.competeData.find(r => r.groupId === data.groupId && r.benefitId === data.benefitId && r.segmentId === data.segmentId);

        getCriticalCapabilityParent.criticalCapacity[index].text = value
        this.setState({ competeData : this.state.competeData})
    }

    accountCCWT = (data) => {
        let numbersArr = [];

        this.state.competeData.map((i,index )=> {
            if( data.groupId === i.groupId && data.segmentId === i.segmentId){
                i.criticalCapacity.map((count,index )=> {
                    return  numbersArr.push({
                                ccWt: count.ccWt,
                            // groupId: i.groupId,
                            //     segmentId: i.segmentId,
                            })
                })
            }

        })
        this.setState({ countCCWT : numbersArr })

    }

    onChangeCompetitors = (e) => {
        let value = e.target.value;
        for (let item of this.state.competitorsGroupsData) {
            if(item.groupId === value ) {
                item.important = true
            }else{
                item.important = false
            }
        }
    }

    onChangeRatingValue = (e, data, index) => {
        let value = e.target.value;
        let getItem = this.state.competeData.find(r => ( r.groupId === data.groupId) && ( r.segmentId === data.segmentId) )

        getItem.criticalCapacity[index].rating = value


        this.setState({ competeData: this.state.competeData}, this.totalScore() )

    }

    onChangeCompetitorsRatingValue = (e, data, groupData, index) => {
        let value = e.target.value;
        let getItem = this.state.competeData.find(r => ( r.groupId === data.groupId) && ( r.segmentId === data.segmentId) )

        //getItem.criticalCapacity[index].rating = value

        let isExist = getItem.criticalCapacity[index].competitors ? getItem.criticalCapacity[index].competitors.find(r => ( r.competitorId === groupData.competitorId))  : false;

        if(isExist) {
            isExist.rating = value
        } else{
            if(getItem.criticalCapacity[index].competitors){
                getItem.criticalCapacity[index].competitors.push({
                    competitorId: groupData.competitorId,
                    rating: value
                })
            } else{
                getItem.criticalCapacity[index].competitors = []
                getItem.criticalCapacity[index].competitors.push({
                    competitorId: groupData.competitorId,
                    rating: value
                })
            }

        }
        this.segmentTotalScore();

        this.setState({ competeData: this.state.competeData })
    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                <div className='rect1'/>
                <div className='rect2'/>
                <div className='rect3'/>
                <div className='rect4'/>
                <div className='rect5'/>
                </div>
            </div>
        );
    }

    segmentTotalScore = () => {
        this.state.tabs.map((tabItem, key) => {
            let countConpenScore = [];
            let competitorTotal = [];
            const groupId = this.state.tabs.find(r => r.groupId === tabItem.groupId).groupId;
            const segmentId = this.state.tabs.find(r => r.segmentId === tabItem.segmentId).segmentId;
            this.state.competeData.map((i,index )=> {
                if( groupId === i.groupId && segmentId === i.segmentId){
                    i.criticalCapacity.map((critItem,index )=> {

                        this.state.competitorsGroupsData.map((competitorsData, key) => {
                            if(competitorsData.important){
                                let rateVal = critItem.competitors ?critItem.competitors.find(r =>  r.competitorId === competitorsData.competitorId) : {rating: '1'};
                                let valScore = rateVal ? +critItem.ccWt * +rateVal.rating : +critItem.ccWt;
                                countConpenScore.push({
                                    score: valScore,
                                    competitorId: competitorsData.competitorId
                                })
                            }
                        })
                    })

                    this.state.competitorsGroupsData.map((competitorsData, key) => {
                        if(competitorsData.important){
                            let val = 0;
                            let id;

                            countConpenScore.map((item, key) => {
                                if(item.competitorId === competitorsData.competitorId ) {
                                    val = val + +item.score
                                    id = item.competitorId
                                }

                            })

                            competitorTotal.push({
                                value: val,
                                competitorId: id

                            });
                            i.competitorTotal = competitorTotal;
                        }
                    })


                }
            })
        })
    }

    totalScore = () => {
        let countScore  = 0;
        this.state.competeData.map((i,index )=> {
            i.criticalCapacity.map((critItem,index )=> {
                let valScore = critItem.rating ? +critItem.ccWt * +critItem.rating : +critItem.ccWt;
                countScore = +countScore + valScore;
                //i
            })
            i.totalScore = countScore

        })
        this.setState({ totalScore: countScore})
    }

    printPage = () => {
        let html = `<div></div>`
        let w = window.open();
        w.document.write(html);
        w.print();
        w.close();
    }

    render() {

        return (
            <div className='criteria-content'>
                <div className='step-bar'>
                    <div className='step step-three arrow-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-three arrow-step'>
                        <p>Step 2</p>
                    </div>
                    <div className='step step-three arrow-step active-step'>
                        <p>Result</p>
                    </div>
                </div>
                <div className='container-fluid'>
                    {!this.props.compete.competeFetching &&

                        <div className='row'>
                            <div className="col-md-8">
                                <div className="criteria-title-box">
                                    <h5>Results</h5>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className='card'>
                                    <div className='card-body'>
                                        { !this.state.createNewTabPending &&
                                            <WeightBenefitsTabs
                                                tabs={this.state.tabs}
                                                // challengeStatementData={this.props.challengeStatement.getChallengeStatementData}
                                                benefitsData={this.state.benefitsData}
                                                competeData={this.state.competeData}
                                                competeOldData={this.state.competeOldData}
                                                onChangeWT={this.onChangeWT}
                                                onChangeCriticalCapability={this.onChangeCriticalCapability}
                                                countCCWT={this.state.countCCWT}
                                                competitorsGroupsData={this.state.competitorsGroupsData}
                                                onChangeCompetitors={this.onChangeCompetitors}
                                                onChangeRatingValue={this.onChangeRatingValue}
                                                onChangeCompetitorsRatingValue={this.onChangeCompetitorsRatingValue}
                                            />
                                        }

                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-12'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <div className='btn btn-success'

                                        onClick={() => this.onNextButtonClick()}
                                        >Next</div>
                                        {/* <a href="/toolkit" className='btn empty-btn default'>Back</a> */}
                                        <div className='btn empty-btn default' onClick={() => this.props.groupStateBack()}>Back</div>


                                        {/* <Link to={'/prioritizer/'+this.props.projectId} className='btn btn-success'> Next </Link> */}
                                        <div  className='btn btn-success'> Next </div>
                                        <Link to='/toolkit' className='btn btn-success'> Done </Link>
                                        <div className='btn empty-btn default'
                                        // onClick={this.downloadPDF}
                                        >
                                        Save PDF</div>
                                        <div className='btn empty-btn default' onClick={this.printPage} >Print</div>
                                        <div className='btn empty-btn default' onClick={() => this.props.stateBack()}>Back</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    {/* { this.props.compete.competeFetching &&
                        <div className='col-sm-12'>
                            <div className='card'>
                                <div className="card-body">
                                    {this.elementInfiniteLoad()}
                                </div>
                            </div>
                        </div>
                    } */}

                    {/* { this.state.abilityToCompeteError &&
                        <AbilityToCompeteError
                        abilityToCompeteErrorModal={this.abilityToCompeteErrorModal}
                        />
                    } */}
                </div>
            </div>
        )
    }
}
export default (Result);



// WEBPACK FOOTER //
// ./src/components/DifferentialAdvantage/Result/Result.jsx